// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./CommunicationModeControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";

// Container for all communication mode controls provided for the Communication Mode section
// in the Remote Operation Panel.
export default function CommunicationModeControls(props: Props): Component {
  return (
    <PanelSection label="Communication Mode">
      {props.modes.map((mode) => (
        <div className={`col ${styles.controlColumn}`} key={mode.value}>
          <button
            className="btn btn-primary"
            type="button"
            disabled={props.disabled}
            onClick={() => props.onChangeCommunicationMode(mode.value)}
          >
            {mode.label}
          </button>
        </div>
      ))}
    </PanelSection>
  );
}

interface Props {
  modes: Mode[];
  disabled: boolean;
  onChangeCommunicationMode: (communicationMode: string) => void;
}

interface Mode {
  value: string;
  label: string;
}
